import React from 'react'

const QuoteContactForm = ({onNext}) => {
  return (
      <form >
                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                                <label className="form-label text-dark fw-bold" for="name">Name</label>
                                <input className="form-control" id="name" type="text" />
                                <div className="text-danger">

                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <label className="form-label text-dark fw-bold" for="email">Phone Number</label>
                                <input className="form-control" id="email" type="email" required="" />
                                <div className="text-danger">

                                </div>
                            </div>

                            <div className="col-12 col-md-6 mb-3">
                                <label className="form-label text-dark fw-bold" for="email">Email Address</label>
                                <input className="form-control" id="email" type="email" required="" />
                                <div className="text-danger">

                                </div>
                            </div>

                            <div className="col-12 col-md-6 mb-3">
                                <label className="form-label text-dark fw-bold" for="email">Company Name</label>
                                <input className="form-control" id="email" type="email" required="" />
                                <div className="text-danger">

                                </div>
                            </div>
                        </div>


                        <div className="text-end">
                            <button onClick={()=>{onNext()}} className="btn-fill text-white p-2 rounded-3 mt-2 fw-bold" type="submit">
                                Next<i className="fa-solid fa-arrow-right text-white ms-2"></i>
                            </button>
                        </div>
                    </form>
  )
}

export default QuoteContactForm
